import React from 'react';
import { FormInput } from 'react-form';
import _ from 'lodash';
import { Checkbox } from 'material-ui';

export default ( {
  containerClassName,
  checkedOptions,
  field,
  labelKey,
  options,
  labelPosition,
  ...rest
} ) => {

  return (
    <FormInput field={field} className={containerClassName}>
      {( { setValue, getValue } ) => {
        return (
          _.map( options, ( option ) =>
            <Checkbox
              key={option.id}
              label={option[labelKey || 'label']}
              labelPosition={labelPosition || 'left'}
              checked={!!_.find( getValue(), { id: option.id } )}
              onCheck={event => {
                let values = getValue() || [];

                if( event.target.checked ) {
                  values.push( option )
                } else {
                  let unCheckedIndex = _.findIndex( getValue(), ( value ) =>
                    value.id.toString() === event.target.value );
                  values.splice( unCheckedIndex, 1 );
                }
                setValue( values )
              }}
              {...rest}
            />
          )
        )
      }}
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/CheckboxGroup/index.js